export function isBase64Image(imgB64:string | ArrayBuffer | null) {
    // Expresión regular para verificar el formato Base64 de imágenes
    const base64Pattern = /^data:image\/(png|jpg|jpeg|gif|bmp);base64,/;
    return base64Pattern.test(typeof imgB64 == 'string' ? imgB64 : '' );
}
